"use client";

import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";
import { useRouter } from "@/lib/useRouter";

export const useSetupCheckAuthenticated = () => {
  const router = useRouter();

  const basicUser = useQuery({
    queryKey: ["users.me"],
    queryFn: async () => {
      const res = await api.client.users.me();
      return res.result;
    },
    staleTime: 5000 * 60 // 5 minutes
  });

  useEffect(() => {
    if (!basicUser) {
      router.push("/auth/login");
    }
  }, [basicUser, router]);

  return basicUser;
};
